export const PADDING_BOTTOM = 'space-1200';
export const PADDING_TOP = 'space-1400';
